import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parsePrice'
})
export class ParsePricePipe implements PipeTransform {

  transform(price: number): string {
    if(typeof price === 'undefined' || price === null) {
      return "Sin precio"
    }
    return `$${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  }

}
